module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Uncle Wiggily's June Bug friends")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_4",
      "title": "[Pg 4]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter2",
    attrs: {
      "id": "i002"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Uncle Wiggily running",
      "id": "id-2773096063416545713",
      "src": "Images/img0001.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i004"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "June bug",
      "id": "id-6323335149767255415",
      "src": "Images/img0002.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("One evening, after Uncle Wiggily, the nice bunny rabbit gentleman,\nhad been out all day, looking in the woods for adventures, he\ncame home to his hollow stump bungalow. He and Nurse Jane\nFuzzy Wuzzy sat down to read. It was a warm night and the window\nwas open. All of a sudden there was a loud buzzing sound in the\nroom. “What’s that?” asked Uncle Wiggily, looking over his glasses.\n“Oh, it’s a big June Bug!” cried Nurse Jane. “The largest I have\neven seen! Oh, if it gets tangled in my hair I’ll never get it out!”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_5",
      "title": "[Pg 5]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i005"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "June bug",
      "id": "id-3996501813955967229",
      "src": "Images/img0003.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Nonsense, Nurse Jane! A June Bug cannot harm you,” said\nUncle Wiggily. But the muskrat lady grew very excited. She stood\nup on a chair and flapped her paper at the Bug. Uncle Wiggily\ntook his tall silk hat in one paw and the tea strainer in the other and\nsaid he would catch the buzzing creature and let him sleep in the\npansy bed. “There’s no harm in him,” said the bunny, “and who\nknows when you may want a June Bug to do you a favor?” After\na while Uncle Wiggily caught the insect and gently put him to bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_6",
      "title": "[Pg 6]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i006"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Uncle Wiggily with Nannie and Billie",
      "id": "id-1143881482622137517",
      "src": "Images/img0004.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The next day, after Uncle Wiggily had been so kind to the June\nBug, putting him in the pansy bed, the rabbit gentleman was out\nwalking in the woods with Nannie and Billie Wagtail, the two goat\nchildren. “Tell us more about the funny June Bug, Uncle Wiggily,”\nbleated Billie. “He was funny, but Nurse Jane was afraid of him,”\nsaid Uncle Wiggily, laughing. “I caught him in the tea strainer and\ngave him some sugar. He said he would do me a favor some day, if\nhe could. But wait a minute. That looks like danger ahead!”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_7",
      "title": "[Pg 7]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i007"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Uncle Wiggily with Nannie and Billie",
      "id": "id-4814214133209226739",
      "src": "Images/img0005.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Uncle Wiggily, Nannie and Billie Wagtail came to a stop just\nat the edge where some sticks were criss-crossed on the woodland\npath. The bunny thought it was a trap and it was. All of a sudden\nUncle Wiggily, Billie and Nannie fell into a deep pit which the bad\nBazumpus had dug, hoping to catch the bunny. “Oh, dear!” bleated\nthe little goat girl. “If ever we wanted help it is now! Where is that\nJune Bug, Uncle Wiggily?” Billie tried to scramble out by digging\nhis horns in the side of the pit, but could not. Oh, what trouble!")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_8",
      "title": "[Pg 8]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i008"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Uncle Wiggily with Nannie and Billie",
      "id": "id-6835978850260899916",
      "src": "Images/img0006.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("After Uncle Wiggily, Billie and Nannie had tried to get out of\nthe pit, only to find themselves slipping back all the while, they suddenly\nheard a buzzing sound up above them, and there was the June\nBug. “I want to thank you again, Uncle Wiggily, for being so kind\nto me last night,” buzzed the Bug. “I saw you fall into this pit, as I\nwas flying away from your bungalow a little while ago. Now I am\ngoing to help you out.” Billie Wagtail shook his horns. “I don’t\nsee how even a big June Bug can help us,” he said. “Oh, dear!”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_9",
      "title": "[Pg 9]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i009"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Lots of June bugs",
      "id": "id-5214500745074145859",
      "src": "Images/img0007.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("After the June Bug had looked down in the pit the Bazumpus\nhad dug, the insect flew away, saying: “I’ll soon be back with a lot\nof my sisters, brothers, cousins, uncles and aunts, and we’ll get you\nout of the pit, Uncle Wiggily.” The bunny said that would be very\nkind. So the June Bug fluttered his wings and whistled on his hind\nlegs and hundreds of other bugs buzzed up to see what was the\nmatter. “We must make a ladder of grass stems so Uncle Wiggily\ncan get out of the pit,” said the big June Bug.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_10",
      "title": "[Pg 10]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i010"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "June bugs left Uncle Wiggily",
      "id": "id-8307236361761662727",
      "src": "Images/img0008.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Buzzing their wings, and weaving with their legs, the kind June\nBugs soon made a long, strong grass ladder. “Now,” said the big\nJune Bug, “we will carry it to the pit, lower it down, fasten the upper\nend to a tree, and Uncle Wiggily, Nannie and Billie can climb out.”\nThe bad old Bazumpus, and his club, by which he hoped to knock\nsome souse off Uncle Wiggily’s ears, saw the bugs marching along\nwith the grass ladder. “I wonder what they are going to do?”\nthought the bad chap. “I must watch and see.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_11",
      "title": "[Pg 11]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i011"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Uncle Wiggily and goat children",
      "id": "id-6466661154278272937",
      "src": "Images/img0009.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Reaching the pit, in which were Uncle Wiggily and the goat\nchildren, the June Bugs fastened the ladder so it would not slip, and\ntossed the other end down in the hole. Then Nannie and Billie\nclimbed up, and then it was Uncle Wiggily’s turn. “See, Billie, I told\nyou a June Bug could help us,” said the bunny gentleman, as he got\nto the top of the pit. “But who dug that hole?” asked Mr. Longears.\n“It was the Bazumpus!” buzzed the largest June Bug. “Yes, and\nthere he is now!” cried Nannie, as she saw the bad creature. “Look!”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_12",
      "title": "[Pg 12]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i012"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "",
      "id": "id-5642026601034385166",
      "src": "Images/img0010.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Lang")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Campbell")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n6-6-20"), _c('br', {
    staticClass: "calibre5"
  })])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("As soon as the rabbit was safely out of the pit, the biggest June\nBug cried: “Now, my friends, since we have saved Uncle Wiggily\nand paid him back for the favor he did me, chase the Bazumpus!”\nAnd all the Bugs chased the bad chap, tickling him with long spears\nof grass so that he ran away as fast as he could go. Nannie and Billie\ndanced for joy because their bunny uncle was saved, and Mr. Longears\nshook paws with the big June Bug and invited him to come to\ndinner that day. So everybody was happy but the Bazumpus.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_13",
      "title": "[Pg 13]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("And if the Ironing board doesn’t jump on the back of the horse radish, and"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\nride into the blue water of the laundry tubs, the next"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\npictures and story will tell how")]), _vm._v(" "), _c('div', {
    staticClass: "figcenter4",
    attrs: {
      "id": "i013"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Alligator wearing paint can",
      "id": "id-1450786957990828869",
      "src": "Images/img0011.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("UNCLE WIGGILY PAINTED HIS"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\nBUNGALOW: SEE THE LADDER SLIP! SEE THE"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\nLADDER FALL! BUT DEAR OLD UNCLE WIGGILY WAS"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\nSCARCELY SCRATCHED AT ALL! BUT THE ALLIGATOR! OH MY!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_14",
      "title": "[Pg 14]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i014"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Uncle Wiggily on ladder painting",
      "id": "id-9003578887910104478",
      "src": "Images/img0012.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Nurse Jane ought to like the bungalow much better after I paint\nit sky blue pink,” said Uncle Wiggily as he stood on a ladder putting\nsome dabs of color on his hollow stump house. “I hope nothing happens\nwhen I am up here. If I should fall in the pots of paints I’d look\nlike some scrambled Easter eggs.” Uncle Wiggily had used up nearly\nall the color in one pot when he saw Billie Wagtail, the goat, and\nJackie and Peetie Bow Wow coming along. “I’ll ask one of them\nto hand me another pot of paint,” said the bunny.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_15",
      "title": "[Pg 15]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i015"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Uncle Wiggily on ladder with goat",
      "id": "id-576715478644359536",
      "src": "Images/img0013.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Hello, boys!” called Uncle Wiggily, as Billie, Jackie and Peetie\ncame near. “Will one of you please hand me up another pot of red\npaint? My can is almost empty.” Billie the goat said he’d bring\nup some red paint, but, instead, just for a joke, he took up some\ngreen paint to Uncle Wiggily. “Won’t he be surprised when he\nstarts daubing green paint over where he put the red,” said Jackie\nto Peetie. “It will be a good joke,” agreed Peetie. “But I hope he\ndoesn’t get mad at us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_16",
      "title": "[Pg 16]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i016"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Uncle Wiggily with green paint",
      "id": "id-3129754409115447890",
      "src": "Images/img0014.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Uncle Wiggily was so busy talking to Billie, Jackie and Peetie\nthat the bunny rabbit never noticed the color of the paint the goat\nboy handed up to him. And, before he knew it, Mr. Longears had\ndaubed some green color on where it ought to have been red. “Oh\nmy! Nurse Jane will not like this a bit!” cried Uncle Wiggily. “I\ndid it for a joke!” laughed Billie. “Wait a minute and I’ll hand you\nup the right color.” Nearer and nearer came the skillery-scallery\nalligator.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_17",
      "title": "[Pg 17]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i017"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Alligator trying to get Uncle Wiggily",
      "id": "id-8275749523856937226",
      "src": "Images/img0015.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("All of a sudden, as Billie was getting ready to take up the right\npot of red paint, up rushed the funny old skillery scallery alligator,\nwith the double jointed tail. “Ah ha, Mr. Longears! At last I\nhave you!” cried the ’gator. “Come down off that ladder until\nI nibble a bit of your souse!” Uncle Wiggily was so surprised that\nhe spilled some paint on Jackie, Peetie and Billie. But still the\nbunny rabbit gentleman would not come down to have his souse\nnibbled.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_18",
      "title": "[Pg 18]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i018"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Alligator lifts ladder",
      "id": "id-7467705901314829441",
      "src": "Images/img0016.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Well, if you won’t come down nice and pretty when I tell\nyou to, so I may have some of your souse, I’ll make you tumble!”\nsaid the bad ’gator to Uncle Wiggily. Then the unpleasant chap\nyanked the ladder out from the side of the hollow stump bungalow\nand the bunny rabbit gentleman began to fall. “Oh, I am almost\nsure I am going to have an adventure this time!” cried Uncle Wiggily.\n“Something is going to happen!” And Billie, Jackie and Peetie\nthought the same thing.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_19",
      "title": "[Pg 19]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i019"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Uncle Wiggily ends up in a tree",
      "id": "id-6588569620530135569",
      "src": "Images/img0017.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The skillery scallery alligator pulled the ladder so hard, hoping\nto make Uncle Wiggily fall, that the ladder toppled into a tree near\nby. Uncle Wiggily gave a jump and landed on one of the branches.\n“Are you coming down out of that and let me nibble your souse?”\nasked the snippy-snappy ’gator. Uncle Wiggily said he was not.\n“Then with my rough nutmeg grater tail I’ll saw down the tree and\nget you anyhow,” snarled the bad chap. “I’ll saw the tree down\nand get your souse!”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_20",
      "title": "[Pg 20]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i020"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Alligator sawing tree",
      "id": "id-4140919994349466876",
      "src": "Images/img0018.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Indeed I am not coming down and let you have any of my\nsouse!” said Uncle Wiggily to the bad ’gator at the foot of the tree.\n“Very well then, now I’ll begin to saw!” gargled the bad chap. So\nwith his tail, which was just like a saw, he began to cut down the\ntree. “Oh, we must save Uncle Wiggily!” whispered Billie the\ngoat. “Yes, but how can we?” asked Jackie. “I know,” barked\nPeetie. “We’ll paint the alligator’s tail red, and he’ll think he has\nthe nose-bleed!”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_21",
      "title": "[Pg 21]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i021"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Alligator gets painted",
      "id": "id-6605576596014650684",
      "src": "Images/img0019.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("All of a sudden, when the alligator had the tree almost sawed\nthrough, and it was beginning to fall with Uncle Wiggily in it, the\nthree animal boys rushed up with their pots of paint. “Splatter him\ngood!” barked Jackie, and he and Peetie and Billie splashed different\nkinds of paint on the bad ’gator. “Oh my goodness me!” grunted\nthe skillery scallery chap. “This will spoil my complexion! This\nis no place for me! I’ll get Uncle Wiggily’s souse some other time,\nI guess.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_22",
      "title": "[Pg 22]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i022"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "",
      "id": "id-1898066381966240109",
      "src": "Images/img0020.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Lang Campbell")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre14"
  }, [_vm._v("7-25-20")]), _c('br', {
    staticClass: "calibre5"
  })])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jackie, Peetie and Billie splashed so much paint on the ’gator,\neven putting some in his eyes, that the bad chap was glad enough\nto run away. He looked like a broken piece of the rainbow. Uncle\nWiggily easily got down out of the fallen tree, and he felt so happy,\nat saving his souse, that he danced a jig around the paint pots with\nthe doggies and the goat. “Well I never!” exclaimed Nurse Jane.\n“This is a funny way to paint a red bungalow green, Uncle Wiggily!”\nBut the bunny gentlemen only laughed.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_23",
      "title": "[Pg 23]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("And if the slice of bread doesn’t try to jump out from under the butter, and"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\nlet the jam fall on the table cloth, the next"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\npictures and story will tell how")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter5",
    attrs: {
      "id": "i023"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Pig selling roses",
      "id": "id-1090530709931035348",
      "src": "Images/img0021.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("UNCLE WIGGILY PICKED SOME MAY"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\nFLOWERS. HE DIDN’T KNOW WHERE THEY CAME FROM,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\nBUT THE ANIMAL BOYS DID. OH, WHAT A SHAME! JUST LOOK!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_24",
      "title": "[Pg 24]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i024"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Uncle Wiggily visits Wibblewobble",
      "id": "id-7038380628295676688",
      "src": "Images/img0022.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("One day Uncle Wiggily Longears stopped at the home of Mrs.\nWibblewobble, the duck lady. Nurse Jane Fuzzy Wuzzy had asked\nthe bunny gentleman to call and return an egg she had borrowed.\nUncle Wiggily found Mrs. Littletail, the rabbit, Mrs. Bushytail, the\nsquirrel, Mrs. Bow Wow, the dog lady, and Mrs. Kat, the pussy lady,\nat Mrs. Wibblewobble’s house. “Is this a party?” asked Uncle Wiggily.\n“Oh, no,” said Mrs. Wibblewobble, “but I could make it one if\nI had a few nice May blossoms.” Uncle Wiggily said he’d get some.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_25",
      "title": "[Pg 25]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i025"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Uncle Wiggily looking for May flowers",
      "id": "id-7365875033207104968",
      "src": "Images/img0023.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Uncle Wiggily went into the early, green spring woods. He\nbegan looking at the ground. Pretty soon he met Jimmie Wibblewobble,\nthe duck, and Curly and Floppy Twistytail, the two piggie\nboys. “What are you looking for, Uncle Wiggily?” asked Floppy.\n“For some nice May flowers to make pretty bouquets so Mrs. Wibblewobble\ncan have them for her little reception party,” answered the\nbunny. “But, boys, I am sorry to say I haven’t yet found a single\nblossom.” The animal boys felt sad for Uncle Wiggily.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_26",
      "title": "[Pg 26]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i026"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Pigs and duck",
      "id": "id-8002821969612910403",
      "src": "Images/img0024.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Hey, fellows, I know how we can have some fun!” quacked\nJimmie the duck. “How?” asked Curly, while Floppy balanced a\nstick and a leaf on the end of his nose, like a juggler in the circus.\n“Uncle Wiggily will never find any flowers in the woods. It is too\nearly,” said Jimmie. “But near my house are a lot of ladies hats,\nwith some dandy flowers on. We could take some off, plant ’em in\nthe woods where Uncle Wiggily would find them and then he’d be\nhappy.” The two piggie boys said that would be fun. Now let’s see.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_27",
      "title": "[Pg 27]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i027"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Pigs and duck",
      "id": "id-605647073146029668",
      "src": "Images/img0025.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jimmie Wibblewobble, the duck boy, meaning no harm, of\ncourse, led Curly and Floppy back to his house. Mrs. Wibblewobble\nand her animal lady friends were so busy talking that they did not\nnotice what the boys did. The boys began pulling the pretty blossoms\noff the hats. “We’ll stick them in the ground among the trees, and\nlead Uncle Wiggily to them,” quacked Jimmie. “He’ll think they’re\nreal blossoms and he’ll pick a big bouquet.” Floppy laughed and\nCurly said: “We ought to put perfume on ’em and make ’em smell.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_28",
      "title": "[Pg 28]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i028"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Pigs and duck",
      "id": "id-8980906105704833761",
      "src": "Images/img0026.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("After Jimmie, Curly and Floppy had pulled from the ladies’ hats\nas many of the make-believe flowers as they wanted, the animal boys\nhurried off to the woods again. “I’ll get my mother’s perfume atomizer\nbottle and we’ll make the flowers smell as sweet as real ones,”\ngrunted Floppy. And in the picture you see how the animal chaps\nplanted the artificial flowers in the green moss of the woods. Floppy\nsprayed some lovely perfume over them, so that they smelled just\nas real as anything. Meanwhile Uncle Wiggily was out of luck.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_29",
      "title": "[Pg 29]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i029"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Rabbit, pigs, and duck",
      "id": "id-3293576831641408639",
      "src": "Images/img0027.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("After Jimmie the duck, and the two piggie boys had planted the\nmake-believe flowers, and had sprayed them with perfume, they ran\noff through the trees and found Uncle Wiggily. “Oh, come with us!”\nquacked Jimmie. “We know where there are some lovely flowers\nyou can pick for the reception party at my house!” “It is very kind\nof you boys,” said the rabbit gentleman. “I have been looking all\nover for May flowers, but could not find any.” And when Jimmy,\nCurly and Floppy pointed to the blossoms the bunny felt very jolly.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_30",
      "title": "[Pg 30]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i030"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Rabbit, pigs, and duck",
      "id": "id-4454692143716067310",
      "src": "Images/img0028.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Uncle Wiggily began picking a bouquet of what he thought were\nreal flowers for Mrs. Wibblewobble. He filled one paw with a big\nbunch of the artificial blossoms. “How nice and sweet they smell!”\nsaid the bunny, holding a rose to his nose. “We are glad you like\nthem,” quacked Jimmie, politely. “Don’t let Uncle Wiggily see that\nperfume bottle, Floppy!” grunted Curly in a whisper. Floppy hid the\natomizer behind his back and Uncle Wiggily kept on picking flowers.\nAll this while Mrs. Wibblewobble and the ladies were talking.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_31",
      "title": "[Pg 31]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i031"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "Uncle Wiggily with flowers",
      "id": "id-2438138350546353406",
      "src": "Images/img0029.jpg"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("After Uncle Wiggily had picked a big bouquet of what he\nthought were sweet-smelling May flowers, he took them to Mrs.\nWibblewobble. The ladies were still talking. “Please accept these\nMay posies which I picked in the woods for you, Mrs. Wibblewobble,”\nsaid Uncle Wiggily with a polite bow. “Oh, how lovely and kind of\nyou!” quacked the duck lady, as she took the blossoms. “And how\nlovely they smell. Just like perfume!” All of a sudden Mrs. Littletail\nlooked out in the room where the hats had been left. Oh, dear!")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_32",
      "title": "[Pg 32]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter3",
    attrs: {
      "id": "i032"
    }
  }, [_c('img', {
    staticClass: "w",
    attrs: {
      "alt": "",
      "id": "id-1131752182640781432",
      "src": "Images/img0030.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "center1"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Lang Campbell")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n5-2-20"), _c('br', {
    staticClass: "calibre5"
  })])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Oh, Uncle Wiggily!” quacked Mrs. Wibblewobble, as she\nlooked at her hat. “Oh, Uncle Wiggily! How could you be so\ncruel?” The bunny gentleman did not know what to say. Just then\nMrs. Littletail saw the animals running away. “Did they show you\nwhere to get the May flowers, Uncle Wiggily?” asked the rabbit lady.\n“Yes,” answered Mr. Longears. “Oh, the little rascals!” quacked\nMrs. Wibblewobble. “It wasn’t Uncle Wiggily’s fault at all, and we\ncan sew the flowers back on our hats.” And this they did.")])]), _vm._v(" "), _c('p', [_vm._v("THE END.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0